document.addEventListener('DOMContentLoaded', function () {
	const splideElem = document.querySelector('.mm-products-splide');
	
	if (!splideElem) {
		return;
	}

	const progressBar = splideElem.querySelector('.mm-splide-progress-bar');

	const splideCards = new Splide(splideElem, {
		type: 'slide',
		arrows: false,
		pagination: false,        
		autoWidth: true,
		perMove: 1,
		perPage: 1,
		gap: 16,   
		breakpoints: {
			768: { 
				gap: 16   
			},
		},
	});

	// Maj progress bar seulement si elle existe
	if (progressBar) {
		const updateProgressBar = () => {
			const totalSlides = splideCards.Components.Elements.slides.length;
			const currentSlide = splideCards.index + 1; 
			const progress = (currentSlide / totalSlides) * 100;
			progressBar.style.width = `${progress}%`;
		};

		splideCards.on('move', updateProgressBar);
		splideCards.on('mounted', updateProgressBar);
	}

	splideCards.mount();
});